export default {"src":"/_next/static/media/sticker-2.59090b8f.svg","height":273,"width":273,"blurWidth":0,"blurHeight":0};